import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLegalStatus, type LegalStatusItem } from "@/integrations/backend/legal";
import { CATALOG_STALE_BASE_MS, staleTimeWithJitterFromKey } from "@/lib/query-cache";
import { queryKeys } from "@/lib/query-keys";

export interface LegalDocStatus {
  document: {
    id: string;
    type: "terms" | "privacy" | "liability_waiver";
    version: number;
    title: string;
    content: string;
    published_at: string | null;
    created_at: string | null;
  };
  accepted_at: string | null;
  is_accepted: boolean;
  most_recent_acceptance_at: string | null;
}

const legalStatusKey = queryKeys.legal.status;

export function useLegalStatus() {
  const queryClient = useQueryClient();
  const q = useQuery({
    queryKey: legalStatusKey,
    queryFn: getLegalStatus,
    staleTime: staleTimeWithJitterFromKey(CATALOG_STALE_BASE_MS, [...legalStatusKey]),
  });

  const refetch = async () => {
    await queryClient.invalidateQueries({ queryKey: legalStatusKey });
  };

  return {
    data: (q.data ?? []) as LegalStatusItem[],
    loading: q.isPending,
    error: q.error,
    refetch,
  };
}
